import { useEffect } from "react"
import { getPusherClient } from "../realtime/pusher-client"
import {
	type PerUserChannelHandler,
	RefCountedUserChannelOwner,
} from "../realtime/user-channel-owner"

const userChannelOwner = new RefCountedUserChannelOwner(() => getPusherClient())

export function usePerUserChannelEvent(
	userId: string | undefined,
	eventName: string,
	handler: PerUserChannelHandler,
): void {
	useEffect(() => {
		if (!userId) return
		return userChannelOwner.bind(userId, eventName, handler)
	}, [userId, eventName, handler])
}

export function usePerUserChannelEvents(
	userId: string | undefined,
	eventNames: readonly string[],
	handler: PerUserChannelHandler,
): void {
	useEffect(() => {
		if (!userId) return
		const releases = eventNames.map((eventName) =>
			userChannelOwner.bind(userId, eventName, handler),
		)
		return () => {
			for (const release of releases) release()
		}
	}, [userId, eventNames, handler])
}
